// init.ts used to initialize Patient domain components on startup.

import { PortalLinkedItemType } from "@/Common/Models/Portal/Enums/PortalLinkedItemType";
import { sharedItemProviderFactory } from "@/Portal/Services/SharedItemProviderFactory";
import { ConsultationRequestSharedItemProvider } from "./Services/Portal/ConsultationRequestSharedItemProvider";
import { GrowthChartSharedItemProvider } from "./Services/Portal/GrowthChartSharedItemProvider";
import { MedicalNoteFormSharedItemProvider } from "./Services/Portal/MedicalNoteFormSharedItemProvider";
import { ObstetricalFileSharedItemProvider } from "./Services/Portal/ObstetricalFileSharedItemProvider";
import { WorkSafeBcFormSharedItemProvider } from "./Services/Portal/WorkSafeBcFormSharedItemProvider";

// Growth Chart
sharedItemProviderFactory.registerProvider(PortalLinkedItemType.GrowthChart, new GrowthChartSharedItemProvider());

// Medical Note
sharedItemProviderFactory.registerProvider(PortalLinkedItemType.MedicalNoteForm, new MedicalNoteFormSharedItemProvider());
sharedItemProviderFactory.registerProvider(PortalLinkedItemType.ConsultationRequest, new ConsultationRequestSharedItemProvider());
sharedItemProviderFactory.registerProvider(PortalLinkedItemType.ObstetricalFile, new ObstetricalFileSharedItemProvider());
sharedItemProviderFactory.registerProvider(PortalLinkedItemType.WorkSafeBcForm, new WorkSafeBcFormSharedItemProvider());
